import Currency from "../currency/currency.tsx";
import Spacer from "../spacer/spacer";
import ModelTag from "../model-tag/model-tag";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";
import { useNavigate } from "react-router-dom";

const ModelComponentAccountPlanExecutionSausage = ({
  accountPlanSausageId,
  organisationId,
  organisationName,
  organisationLogoUrl,
  subunits,
  subunitsCurrency,
}) => {
  const navigate = useNavigate();

  return (
    <div className={"flex flex-row gap-2 w-full items-center"}>
      <ModelTag modelId={accountPlanSausageId} isSmall={true} />

      <RaindropClickable
        onClick={() => navigate(`/nimbus/organisations/${organisationId}`)}
      >
        <img
          src={organisationLogoUrl}
          alt="Organisation Logo"
          className="w-6 h-6 rounded-lg"
        />
        <div className="whitespace-nowrap">{organisationName}</div>
      </RaindropClickable>
      <Spacer />
      <Currency subunits={subunits} currency={subunitsCurrency} />
    </div>
  );
};

export default ModelComponentAccountPlanExecutionSausage;
